import { useCallback, useState } from 'react';
import { THUMB_WIDTH, TICK_PROXIMITY_THRESHOLD } from './constants';

export const useSliderInteractions = (
  containerRef: React.RefObject<HTMLDivElement | null>,
  tickPositions: number[],
  thumbPosition: number,
  numberOfTicks: number,
  isInteracting: boolean
) => {
  const [hoveredTick, setHoveredTick] = useState<{ positionX: number; pct: number } | null>(null);
  const [isThumbHovered, setIsThumbHovered] = useState(false);

  const handleMouseMove = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!containerRef.current || isInteracting) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const mouseX = e.clientX - containerRect.left;

      // Find closest tick
      let closestTick: { positionX: number; pct: number } | null = null;
      let minDistance = TICK_PROXIMITY_THRESHOLD;

      tickPositions.forEach((tickPos, index) => {
        const distance = Math.abs(mouseX - tickPos);
        if (distance < minDistance) {
          minDistance = distance;
          closestTick = {
            positionX: tickPos,
            pct: numberOfTicks > 1 ? index / (numberOfTicks - 1) : 0,
          };
        }
      });

      setHoveredTick(closestTick);

      // Check thumb hover
      const thumbRadius = THUMB_WIDTH / 2;
      setIsThumbHovered(Math.abs(mouseX - thumbPosition) <= thumbRadius);
    },
    [containerRef, isInteracting, tickPositions, numberOfTicks, thumbPosition]
  );

  const handleMouseLeave = useCallback(() => {
    setHoveredTick(null);
    setIsThumbHovered(false);
  }, []);

  return {
    hoveredTick,
    isThumbHovered,
    handleMouseMove,
    handleMouseLeave,
  };
};
